import Cookies from "universal-cookie";
import { jbmLangSettings } from "./lang/jbm";
import { bnextLangSettings } from "./lang/bnext";
import { samsarLangSettings } from "./lang/samsar";
import { vammoLangSettings } from "./lang/vammo";
import { magentaLangSettings } from "./lang/magenta";
import { batfinLangSettings } from "./lang/batfin";

export const getOrganizationName = () => {
  const cookies = new Cookies();
  const orgName = cookies.get("orgName");
  return orgName?.toLowerCase();
};

export const isOrganizationJBM = () => {
  return getOrganizationName() === "jbm";
};

export const isOrganizationBNext = () => {
  return getOrganizationName() === "bnext";
};

export const isOrganizationVammo = () => {
  return getOrganizationName() === "vammo";
};

export const isOrganizationSamsar = () => {
  return getOrganizationName() === "samsar";
};

export const isOrganizationMagenta = () => {
  return getOrganizationName() === "magenta";
};

export const isOrganizationBatfin = () => {
  return getOrganizationName() === "batfin";
};

export const getOrganizationLangSettings = () => {
  if (isOrganizationJBM()) {
    return jbmLangSettings;
  }
  if (isOrganizationBNext()) {
    return bnextLangSettings;
  }
  if (isOrganizationSamsar()) {
    return samsarLangSettings;
  }
  if (isOrganizationMagenta()) {
    return magentaLangSettings;
  }
  if (isOrganizationBatfin()) {
    return batfinLangSettings;
  }
  return vammoLangSettings;
};
